import { render, staticRenderFns } from "./InfoCustomModal.vue?vue&type=template&id=7a79dbd6&"
import script from "./InfoCustomModal.vue?vue&type=script&lang=js&"
export * from "./InfoCustomModal.vue?vue&type=script&lang=js&"
import style0 from "./InfoCustomModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports